import * as React from 'react';
import { ConfirmationOptions } from './interface';

// eslint-disable-next-line max-len
const ConfirmationServiceContext = React.createContext<(options: ConfirmationOptions) => Promise<void>
>(Promise.reject);

export default ConfirmationServiceContext;
